export default __webpack_public_path__ + "static/media/Jamal-with-suitcase-and-yellow-background.946e5a6f.svg";